const m = {
  hourTip: '选择小时',
  minuteTip: '选择分钟',
  secondTip: '选择秒数',
  second: '秒',
  yearSuffix: '年',
  monthsHead: '1月_2月_3月_4月_5月_6月_7月_8月_9月_10月_11月_12月',
  months: '一月_二月_三月_四月_五月_六月_七月_八月_九月_十月_十一月_十二月',
  weeks: '一_二_三_四_五_六_日',
  hello: '你好',
  helloMessage: '欢迎来到, Apache SkyWalking APM 系统 !',
  username: '用户名',
  password: '密码',
  title: '标题',
  width: '宽度',
  height: '高度',
  login: '登录',
  signout: '登出',
  dashboard: '仪表盘',
  topology: '拓扑图',
  trace: '追踪',
  alarm: '告警',
  auto: '自动',
  reload: '刷新',
  usermode: '用户模式',
  editmode: '编辑模式',
  currentService: '当前服务',
  currentEndpoint: '当前端点',
  currentInstance: '当前实例',
  currentDatabase: '当前数据库',
  templateConfig: '模版配置',
  copy: '拷贝',
  reset: '重制',
  apply: '应用',
  createGroup: '创建分组',
  groupType: '分组类型',
  groupName: '分组名',
  template: '模版',
  confirm: '确定',
  cancel: '取消',
  createTab: '创建分页',
  tabName: '分页名',
  nouse: '不使用',
  allServices: '所有服务',
  serviceDetail: '服务详情',
  detectPoint: '侦察端',
  callType: '调用类型',
  server: '服务端',
  client: '客户端',
  name: '名称',
  type: '类型',
  cpm: '每分钟请求量',
  sla: 'SLA',
  latency: '延迟',
  avgResponseTime: '平均响应时间',
  avgThroughput: '平均吞吐量',
  avgSLA: '平均SLA',
  all: '全部',
  success: '成功',
  error: '失败',
  service: '服务',
  instance: '实例',
  endpoint: '端点',
  database: '数据库',
  cache: '存储器',
  global: '全局',
  serviceendpoint: '服务端点',
  serviceinstance: '服务实例',
  status: '状态',
  endpointName: '端点名称',
  search: '搜索',
  clear: '清空',
  more: '更多',
  traceID: '追踪ID',
  range: '范围',
  timeRange: '时间范围',
  duration: '持续时间',
  startTime: '开始时间',
  start: '起始点',
  spans: '跨度',
  spanInfo: '跨度信息',
  spanType: '跨度类型',
  time: '时间',
  tags: '标记',
  logs: '日志',
  component: '组件',
  table: '表格',
  list: '列表',
  tree: '树结构',
  filterScope: '过滤范围',
  searchKeyword: '关键字搜索',
  quarterHourCutTip: '最近15分钟',
  halfHourCutTip: '最近30分钟',
  hourCutTip: '最近1小时',
  dayCutTip: '最近1天',
  weekCutTip: '最近1周',
  monthCutTip: '最近1月',
  serverZone: '服务器时区',
  percentResponse: '百分比响应',
  exportImage: '导出为图片',
  comparison: '指标对比',
  queryData: '数据查询',
  previousService: '上一个服务',
  nextService: '下一个服务',
  object: '粒度',
  metrics: '指标',
  ShowInstanceDependency: '展示实例依赖',
  InstanceDependencyTitle: '实例依赖',
};

export default m;
